import { lazy } from "react";
import { Route } from "react-router-dom";
import { AppRoutes } from "@/infra/router";

const SessionSelfReflectionPainPage = lazy(() => import("./SessionSelfReflectionPainPage"));

const SessionSelfReflectionPainfulExercisesPage = lazy(() => import("./SessionSelfReflectionPainfulExercisesPage"));

const SessionSelfReflectionDifficultyPage = lazy(() => import("./SessionSelfReflectionDifficultyPage"));

const SessionSelfReflectionDifficultExercisesPage = lazy(() => import("./SessionSelfReflectionDifficultExercisesPage"));

const SessionSelfReflectionFeedbackPage = lazy(() => import("./SessionSelfReflectionFeedbackPage"));
const SessionRecapPage = lazy(() => import("./SessionRecapPage"));
const TherapyNextSessionPage = lazy(() => import("./TherapyNextSessionPage"));

export const sessionRoutes = [
  <Route
    key={AppRoutes.NextSession}
    path={AppRoutes.NextSession}
    element={<TherapyNextSessionPage />}
  />,
  <Route
    key={AppRoutes.SessionRecap}
    path={AppRoutes.SessionRecap}
    element={<SessionRecapPage />}
  />,
];

export const selfReflectionRoutes = [
  <Route
    key={AppRoutes.SessionSelfReflectionPain}
    path={AppRoutes.SessionSelfReflectionPain}
    element={<SessionSelfReflectionPainPage />}
  />,
  <Route
    key={AppRoutes.SessionSelfReflectionPainfulExercises}
    path={AppRoutes.SessionSelfReflectionPainfulExercises}
    element={<SessionSelfReflectionPainfulExercisesPage />}
  />,
  <Route
    key={AppRoutes.SessionSelfReflectionDifficulty}
    path={AppRoutes.SessionSelfReflectionDifficulty}
    element={<SessionSelfReflectionDifficultyPage />}
  />,
  <Route
    key={AppRoutes.SessionSelfReflectionDifficultExercises}
    path={AppRoutes.SessionSelfReflectionDifficultExercises}
    element={<SessionSelfReflectionDifficultExercisesPage />}
  />,
  <Route
    key={AppRoutes.SessionSelfReflectionFeedback}
    path={AppRoutes.SessionSelfReflectionFeedback}
    element={<SessionSelfReflectionFeedbackPage />}
  />,
];
